module.exports = {"server":"https://seguimiento.upre.gob.bo/ws","serverAuth":"https://seguimiento.upre.gob.bo/ws","serverSigaApi":"https://www.siga.upre.gob.bo/apisiga","timeSessionExpired":90,"debug":false,"onbeforeunload":true,"port":4003,"subDomain":"","portDev":8888}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 196
// module chunks = 0